import Layout from '../../layout';
const specialTopicRouter = {
	path: '/',
	component: Layout,
	redirect: '/',
	name: 'eduSpecialTopic',
	meta: {
		title: '1',
		sort: 4,
	},
	children: [
		{
			path: '/specialTopic',
			component: () => import('@/pages/medical/views/specialTopic/index.vue'),
			name: 'specialTopic',
		},
		{
			path: '/baogao',
			component: () => import('@/pages/medical/views/baogao/index.vue'),
			name: 'hotContent',
		},
		{
			path: '/hylist',
			component: () => import('@/pages/medical/views/hylist/index.vue'),
			name: 'hylist',
		},
		{
			path: '/detailslist',
			component: () => import('@/pages/medical/views/detailslist/index.vue'),
			name: 'detailslist',

		}
	],
};

export default specialTopicRouter;
